import { useEffect, useState } from "react";

import { Box, Grid, Grow, List, ListItem, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

import AccessibleIcon from '@mui/icons-material/Accessible';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WifiIcon from '@mui/icons-material/Wifi';

import { useSocket } from "../../hooks/useSocket";

import { content_table, table_cell_blue, table_padding_pantalla, table_tbody_pantalla, table_thead_pantalla } from "../../styles/TableStyle";

import { ConsultarTodosTurnos } from "../../connections/comun/TurnosConnection";

import { SocketTurnoResponse, TurnoProps } from "../../interfaces/comun/TurnoInterface";

const defaultTurno: TurnoProps = { turno_id: 0, turno_numero: 0, turno_comentarios: '', turno_numero_cubiculo: 0, turno_estado: {id:0, nombre:''} ,turno_tipo: {id:0, nombre:'', nivel:'' }, unidad : { id: 0, clave : '', nombre : '' }, ubicacion: { id: 0, nombre : '', numero : 0 } };

const audio = new Audio('/assets/sounds/siguiente2.mp3');

export const PantallaPage = () => {  

    const [ turnosArray, setTurnosArray ] = useState<TurnoProps[]>([]) ;
    const [ ultimoTurno, setUtimoTurno ] = useState<TurnoProps>( defaultTurno );
    const [ loadFetch, setLoadFetch ] = useState( true );

    const { socket, online } = useSocket();

    const [fecha, setFecha] = useState(new Date());

    useEffect( () => {

        socket.on('message', ( socketMessage: SocketTurnoResponse ) => {
           
            const turno = socketMessage.data;

            if( turno.turno_id !== 0 ){
                setFecha( new Date() );
                if( turno.turno_estado.id === 1 || turno.turno_estado.id === 5 ){ /* 1 'EN ESPERA' , 5 'EN ESPERA DE CUBICULO' */
                    /*setTurnosArray( ( arrays ) => [ ...arrays, turno ]);*/
                    setLoadFetch( true );
                }
                else if( turno.turno_estado.id === 7 || turno.turno_estado.id === 6 || turno.turno_estado.id === 2 || turno.turno_estado.id === 8  ){ 
                    /* 7 'PASE A UBICACION ' , 2 'ATENDIENDO' , 8 'PASE A CUBICULO' , 6 'ATENDIENDO EN CUBICULO'*/

                    setTurnosArray( ( arrays ) => arrays.map( ( elem ) => {
                        if( elem.turno_id === turno.turno_id){
                            elem = { ...turno };
                        }
                        return elem;
                    }));

                    setUtimoTurno( turno );
                    audio.play();

                }
                else if( turno.turno_estado.id === 3 || turno.turno_estado.id === 4 ){ /* 3 'COMPLETADO' , 4 'CANCELADO'  */ 
                    setLoadFetch( true );
                }
            }

        })

        return () => { 
            socket.off('message'); 
        }

    }, [ socket ])
    
    useEffect(() => {
          
        async function obtener(){

            await ConsultarTodosTurnos().then( resp => {

                const { data } = resp;        

                if( data ){
                    
                    const { ultimo_turno, turnos } = data;
                    setUtimoTurno( ultimo_turno ?? defaultTurno );   
                    setTurnosArray( turnos ?? [] );
                    setLoadFetch( false );
                }
                else {
                    setUtimoTurno( defaultTurno );     
                    setTurnosArray( [] );
                    setLoadFetch( false );
                }


            });
        }

        if( loadFetch ){
            obtener();
        }

    }, [ loadFetch ])     

    return (

        <Box className="pantalla">
      
            <Grid container spacing={3} sx={{...content_table}} style={{ minHeight:'84vh' }}>

                {/* Espacio de Lista de Turnos */}
                <Grid size={{ xs: 12, md: 8 }}>

                    <TableContainer sx={{ borderRadius:5, backgroundColor: 'transparent', boxShadow:'none !important'  }}>

                        <Table>

                            <TableHead sx={{ backgroundColor: 'transparent' }}>

                                <TableRow>   
                                    <TableCell sx={{  ...table_thead_pantalla, width: '2%', textAlign: 'center',paddingBottom:'15px' }}></TableCell>
                                    <TableCell sx={{  ...table_thead_pantalla, width: '30%', textAlign: 'center',paddingBottom:'15px' }}>Turno</TableCell>
                                    <TableCell sx={{  ...table_thead_pantalla, width: '50%', textAlign: 'center',paddingBottom:'15px' }}></TableCell>
                                    <TableCell sx={{  ...table_thead_pantalla, width: '20%', textAlign: 'center',paddingBottom:'15px' }}>Ubicación</TableCell>
                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    turnosArray
                                    .slice(0, 15)
                                    .map( ( { unidad, turno_numero, turno_estado, ubicacion, turno_tipo , turno_numero_cubiculo}, index ) => (
                                        
                                        <TableRow key={ index } sx={{...table_tbody_pantalla }} style={ (index % 2 === 0) ? { backgroundColor: 'rgba(35, 77, 123, 0.4)' } : { backgroundColor: '#234d7b' } }>

                                            <Grow 
                                                in
                                                style={{ transformOrigin: '0 0 0' }}
                                                {...( { timeout: 1000 } )}
                                            > 
                                                <TableCell sx={{ ...table_padding_pantalla, fontSize: 12, textAlign: 'center', fontWeight: 'bold' }}>
                                                    {turno_tipo.id===2 ? <CalendarMonthIcon sx={{ color: '#fff', fontSize: 30 }} /> : turno_tipo.id===3 ? <AccessibleIcon sx={{ color: '#fff', fontSize: 30 }} /> : ''}
                                                </TableCell> 
                                            </Grow>
                                            
                                            <Grow 
                                                in
                                                style={{ transformOrigin: '0 0 0' }}
                                                {...( { timeout: 1000 } )}
                                            > 
                                                <TableCell sx={{ ...table_padding_pantalla, fontSize: 30, textAlign: 'center', color:'#fff',  }}>{ unidad.clave }-{ String( turno_numero ).padStart(3,'0') }</TableCell>                                             
                                            </Grow>

                                            <Grow 
                                                in
                                                style={{ transformOrigin: '0 0 0' }}
                                                {...( { timeout: 1000 } )}
                                            > 
                                                <TableCell sx={{ ...table_padding_pantalla, textAlign: 'center',  }} style={{ color: (turno_estado.id===2 || turno_estado.id===6 || turno_estado.id===7 || turno_estado.id===8) ? '#b9dcff' : 'white', fontSize: (turno_estado.id===2 || turno_estado.id===6 || turno_estado.id===7 || turno_estado.id===8) ? '30px' : '25px'  }}>{ turno_estado.nombre }</TableCell> 
                                            </Grow>

                                            <Grow 
                                                in
                                                style={{ transformOrigin: '0 0 0' }}
                                                {...( { timeout: 1000 } )}
                                            > 
                                                <TableCell sx={{ ...table_padding_pantalla, textAlign: 'center', color:'#fff', }}>
                                                    <Typography sx={{ fontSize:'35px'}}> 
                                                        { turno_estado.id === 2 || turno_estado.id === 7 ?  ubicacion.nombre : '' /* 2 'ATENDIENDO' */}
                                                        { turno_estado.id === 6 || turno_estado.id === 8 ? 'Cubículo' : '' /* 6 'ATENDIENDO EN CUBICULO' 8  'PASE A CUBICULO' */}
                                                        &nbsp;
                                                        { turno_estado.id === 2 || turno_estado.id === 7 ? ubicacion.numero : '' /* 2 'ATENDIENDO' */ } 
                                                        { turno_estado.id === 6 || turno_estado.id === 8 ? turno_numero_cubiculo : '' /* 6 'ATENDIENDO EN CUBICULO' 8  'PASE A CUBICULO' */}  
                                                    </Typography>
                                                    
                                                </TableCell> 
                                            </Grow>

                                           

                                        </TableRow>
                                        
                                    ))
                                }

                            </TableBody>

                        </Table>

                    </TableContainer>

                </Grid>
                
                {/* Espacio de Turno Actual */}
                <Grid size={{ xs: 12, md: 4 }}  style={{ paddingLeft:'80px'}}>
                    
                    <Grid container>
                        <Grid size={{ xs: 12, md: 12 }} sx={{ mt: { xs: 2, md: 0 } }} style={{textAlign:'right'}}>
                            <Typography style={{fontFamily: 'Arial', fontSize: 20, color: '#fff',paddingRight:'30px'}}><CalendarMonthIcon sx={{ color: '#fff', fontSize: 30 }} />  
                                &nbsp;{fecha.toLocaleDateString('es-ES', { weekday: 'long' }).charAt(0).toUpperCase() + fecha.toLocaleDateString('es-ES', { weekday: 'long' }).slice(1)}, {fecha.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
                            </Typography>
                            <Box style={{textAlign:'right', padding:'0px'}}>

                                { 
                                    online 
                                    ? 
                                        <List sx={{ listStyleType: 'disc' }} style={{padding:'0px'}}>
                                            <ListItem sx={{fontSize:'.75em', color:'#fff'}} style={{textAlign:'right', padding:'0px'}}>
                                                <ListItemText primary="En línea " style={{paddingRight:'5px'}} /> 
                                                <ListItemIcon>
                                                    <WifiIcon sx={{ color: '#91f36a' }} />
                                                </ListItemIcon>
                                            </ListItem>
                                        </List>
                                    :
                                        <List sx={{ listStyleType: 'disc' }} style={{padding:'0px'}}>
                                            <ListItem sx={{fontSize:'.75em', color:'#fff'}} style={{textAlign:'right', padding:'0px'}}>
                                                <ListItemText primary="Desconectado"  style={{paddingRight:'5px'}}/>
                                                <ListItemIcon>
                                                    <WifiIcon sx={{ color: 'red' }} />
                                                </ListItemIcon>
                                            </ListItem>
                                        </List>
                                }                    

                            </Box>
                        </Grid>
                    </Grid>
                    
                    <Grid container sx={{ mt: 8 }}>

                        <Grid size={{ xs: 12, md: 11 }} sx={{ mt: { xs: 2, md: 0 } }}>

                            <Box mt={2} py={8} sx={{ ...table_cell_blue, padding:5 }}>

                                <Typography style={{fontSize:40, fontWeight:'lighter'}}>Turno</Typography>
                                <Typography sx={{ fontSize: '6rem', lineHeight:.9, textAlign:'center' }}>{ ultimoTurno?.unidad.clave }</Typography>
                                <Typography sx={{ fontSize: 180, lineHeight: 0.9, textAlign:'center' }}>{ ultimoTurno.turno_numero > 0 && String(ultimoTurno?.turno_numero).padStart(3,'0') } </Typography>
                                
                                <hr style={{ marginTop:'40px', marginBottom:'40px',borderColor: '#7fbeeb', borderStyle: 'solid', borderWidth: '0.5px 0 0 0' }} />

                                <Typography sx={{ fontSize:40, color:'#fff', fontWeight:'lighter'}}> { ultimoTurno?.turno_estado.id === 6 || ultimoTurno?.turno_estado.id === 8 ? 'Cubículo' : ultimoTurno?.ubicacion.nombre /* 6 'ATENDIENDO EN CUBICULO' */}</Typography>
                                <Typography sx={{ fontSize: 210, lineHeight: 0.9, color:'#fff' }}>
                                    {ultimoTurno?.turno_estado.id == 6 || ultimoTurno?.turno_estado.id === 8
                                        ? ultimoTurno?.turno_numero_cubiculo
                                        : ultimoTurno?.ubicacion.numero !== 0 && ultimoTurno?.ubicacion.numero
                                    }
                                </Typography>
                            </Box>

                        </Grid>

                    </Grid>

                </Grid>

            </Grid>                      

        </Box>  
        
    )
}
